function coreApiDomain() {
    let url
    switch (location.hostname) {
        case 'control.us.axioms.io':
            url = 'services.us.axioms.io/api'
            break;

        case 'control.us.uat.axioms.io':
            url = 'services.us.uat.axioms.io/api'
            break;

        default:
            url = 'services.example.com/api'
            break;
    }
    return url
}

export default coreApiDomain;